import React, { Fragment } from "react";
import { CheckBoxInput } from "../../../Buttons";
import { FaEdit, FaTimes, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  setOrderRowDisabledAt,
  setCodSelected,
} from "../../../../../redux/Actions/orderAction";
import { Input, Tooltip, message } from "antd";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { selectedOrderRows } from "../../../../../redux/Actions/orderRowAction";
import { prettyDateFormat } from "../../../../../helpers/Utils";
import { have_product_reference } from "../../../../../helpers/OrdersFunctionsGlobal";

function RowsInShipment({
  form_type,
  order_rows,
  orderRowsChange,
  isReturn = false,
}) {
  const or_quantity_manual = useSelector(
    (state) => state.orders.or_quantity_manual
  );

  return (
    <Fragment>
      <span style={{ fontWeight: "400" }}>
        <table className="table table-sm">
          <tbody>
            {order_rows?.map((e) => {
              return (
                <OrderRowRender
                  key={e.id}
                  e={e}
                  or_quantity_manual={or_quantity_manual}
                  orderRowsChange={orderRowsChange}
                  form_type={form_type}
                  isReturn={isReturn}
                />
              );
            })}
          </tbody>
        </table>
      </span>
    </Fragment>
  );
}

const OrderRowRender = ({
  e,
  or_quantity_manual,
  orderRowsChange,
  form_type,
  isReturn,
}) => {
  const dispatch = useDispatch();
  const orderRowData = e.order_row || {};

  const totals = orderRowData?.shipment_order_rows?.reduce(
    (cur, acc) =>
      (acc.deleted_at || acc.canceled_at
        ? 0
        : acc.quantity || Math.floor(acc.order_row?.quantity)) + cur,
    0
  );
  const totalQuantity = parseFloat(orderRowData.quantity || 0);
  const sor_total = totalQuantity - totals;

  const setDisabledOrderRow = async (
    item_id,
    order_id,
    disabled_at,
    shipment_order_row = null,
    params = {}
  ) => {
    if (
      confirm(
        disabled_at
          ? "Are you sure want to mark the product as shipped?"
          : "Are you sure want to unmark the product as shipped?"
      )
    ) {
      const { ok, data } = await dispatch(
        setOrderRowDisabledAt(
          {
            disabled_at: disabled_at ? new Date() : null,
            shipment_order_row,
            ...params,
            form_type,
          },
          order_id,
          item_id
        )
      );

      if (ok) {
        dispatch({
          type: "UPDATE_OR_QUANTITY_MANUAL",
          payload: { [item_id]: "" },
        });
        if (data && !!orderRowsChange)
          orderRowsChange({ type: "UPDATE_ITEM", data });
      }
    }
  };

  const renderCheckBox = (item, disabled_at) => {
    if (orderRowData.disabled_at && item.selected === false) {
      return (
        <div className="d-block">
          <label
            className="ant-checkbox-wrapper cursor-pointer"
            onClick={() => {
              if (!disabled_at) return message.error("You have no quantities");
              setDisabledOrderRow(item.id, orderRowData.order_id, !disabled_at);
            }}
          >
            <span className="ant-checkbox" style={{ top: 0 }}>
              <span className="ant-checkbox-inner d-flex justify-content-center align-items-center">
                <FaTimes color={disabled_at ? "#ff9e00" : "#d83b3b"} />
              </span>
            </span>
          </label>
        </div>
      );
    }
    return (
      <CheckBoxInput
        checked={!!item.selected}
        onChange={() => {
          if (orderRowsChange) {
            orderRowsChange({
              type: "UPDATE_SELECTED",
              data: {
                order_row_id: item.id,
                selected: !item.selected,
              },
            });
          } else {
            dispatch(selectedOrderRows(item.id, orderRowData.order_id));
          }
        }}
      />
    );
  };
  const isCodSelected = useSelector((state) => state.orders.isCodSelected);
  React.useEffect(() => {
    dispatch(setCodSelected(false));
    return () => {
      dispatch(setCodSelected(false));
    };
  }, [dispatch]);
  return (
    <Fragment>
      <tr>
        {/* <td className="align-middle text-center">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: 32 }}
          >
            {renderCheckBox(e, sor_total > 0)}
          </div>
        </td> */}
        <td className="align-middle text-center">
          <span className="px-1">
            {have_product_reference(orderRowData.product_reference) ? (
              orderRowData.product_reference
            ) : (
              <AiOutlineCheckCircle
                className={`text-${orderRowData.parent_id ? "success" : "danger"
                  }`}
              />
            )}
          </span>
        </td>
        <td className="align-middle text-center">
          {or_quantity_manual?.[e.id] ? (
            <div className="d-flex align-items-center">
              {/* <Input
                style={{
                  maxWidth: or_quantity_manual[e.id].toString().length * 50,
                }}
                size="small"
                placeholder={totalQuantity}
                value={or_quantity_manual[e.id]}
                onChange={(val) =>
                  dispatch({
                    type: "UPDATE_OR_QUANTITY_MANUAL",
                    payload: { [e.id]: val.target.value },
                  })
                }
              />
              <FaTimes
                className="ml-2 mr-1 cursor-pointer"
                color="#ff9e00"
                onClick={() =>
                  dispatch({
                    type: "UPDATE_OR_QUANTITY_MANUAL",
                    payload: { [e.id]: "" },
                  })
                }
              /> */}
            </div>
          ) : (
            <div className="d-flex align-items-center">
              {totals}/{Math.floor(totalQuantity)}
              {/* {sor_total > 0 && (
                <FaEdit
                  className="ml-2 mr-1 cursor-pointer"
                  color="#ff9e00"
                  onClick={() =>
                    dispatch({
                      type: "UPDATE_OR_QUANTITY_MANUAL",
                      payload: {
                        [e.id]: +sor_total,
                      },
                    })
                  }
                />
              )} */}
            </div>
          )}
        </td>
        <td className="align-middle">
          <div>{orderRowData.product_name}</div>
        </td>
        <td className="align-middle text-center">
          <span style={{ whiteSpace: "nowrap" }}>
            {Number(orderRowData.unit_price_tax_incl)?.toFixed(2) || 0} &#8364;
          </span>
        </td>
        <td className="align-middle text-center">
          {/* {!orderRowsChange && !orderRowData.disabled_at && (
            <div>
              <Tooltip placement="top" title="Marked product as shipped">
                <AiOutlineCheckCircle
                  className={"text-danger cursor-pointer ml-1"}
                  onClick={() =>
                    isCodSelected
                      ? message.error("Shipment is with COD")
                      : setDisabledOrderRow(
                          e.id,
                          orderRowData.order_id,
                          true,
                          null,
                          {
                            manual_quantity: or_quantity_manual[e.id] || null,
                          }
                        )
                  }
                />
              </Tooltip>
            </div>
          )} */}
        </td>
      </tr>
      {!isReturn && (
        <FilterRowHistory
          order_row_histories={orderRowData.shipment_order_rows}
          setDisabledOrderRow={(shipment_order_row, order_quantity) =>
            setDisabledOrderRow(
              e.id,
              orderRowData.order_id,
              order_quantity - sor_total <= 0 ? true : false,
              shipment_order_row
            )
          }
        />
      )}
    </Fragment>
  );
};

const FilterRowHistory = ({ order_row_histories, setDisabledOrderRow }) => {
  const histories = Array.isArray(order_row_histories)
    ? order_row_histories
    : [];

  if (!histories.length) return null;

  const prettierStatus = (shipment, amount, its_fake) => {
    return (
      <span>
        <div>Quantity shipped: {amount}</div>
        <div>
          <b>
            {its_fake ? (
              "Mark product as shipped"
            ) : (
              <Fragment>
                <span>
                  Shipments:
                  {shipment?.map((title, idx) => (
                    <span key={idx}>
                      {title}
                      {idx === shipment.length - 1 ? "" : ", "}
                    </span>
                  ))}
                </span>
              </Fragment>
            )}
          </b>
        </div>
      </span>
    );
  };

  return histories.map((e, idx) => {
    const check = () => {
      return e.deleted_at || e.canceled_at;
    };
    const checkButton = () => {
      return !check();
    };
    return (
      <tr
        key={idx}
        style={{
          borderLeft: "1px solid #a8e2df",
        }}
      >
        <td className="pl-3 pr-0 py-0 align-middle" colSpan={3}>
          {check() ? (
            <del>
              <small>
                {prettierStatus(
                  e.shipment?.tracking_numbers,
                  e?.quantity || Math.floor(e.order_row?.quantity),
                  e.title === "FAKE" || e.fake === true
                )}
              </small>
            </del>
          ) : (
            <div className="d-flex align-items-center">
              {checkButton() && (
                <Tooltip placement="top" title="Mark product as not shipped">
                  <FaTrash
                    className={"text-danger cursor-pointer mr-1"}
                    onClick={() =>
                      setDisabledOrderRow(
                        e.id,
                        +e?.quantity || Math.floor(e.order_row?.quantity)
                      )
                    }
                  />
                </Tooltip>
              )}
              <small>
                {prettierStatus(
                  e.shipment?.tracking_numbers,
                  e?.quantity || Math.floor(e.order_row?.quantity),
                  e.title === "FAKE" || e.fake === true
                )}
              </small>
            </div>
          )}
        </td>
        <td className="p-0 align-middle text-center" colSpan={1}>
          {check() ? (
            <del>
              <div>
                <small>
                  {e.canceled_user && "Created by: "}
                  {e.user_title}
                </small>
              </div>
              {e.canceled_user && (
                <div className="text-danger">
                  <small>Canceled by: {e.canceled_user}</small>
                </div>
              )}
            </del>
          ) : (
            <small>{e.user_title}</small>
          )}
        </td>
        <td className="p-0 align-middle text-center" colSpan={2}>
          <div className="d-flex justify-content-end align-items-center">
            {check() ? (
              <del>
                <div>
                  <small>
                    {e.canceled_at && "Created: "}
                    {prettyDateFormat(e.created_at)}
                  </small>
                </div>
                {e.canceled_at && (
                  <div className="text-danger">
                    <small>
                      Canceled at: {prettyDateFormat(e.canceled_at)}
                    </small>
                  </div>
                )}
              </del>
            ) : (
              <small>{prettyDateFormat(e.created_at)}</small>
            )}
          </div>
        </td>
      </tr>
    );
  });
};

export default RowsInShipment;
